import LetterBoxContainer from "../../../Components/Applications/LetterBox/LetterBoxContainer";

const LetterBox = () => {
  return <LetterBoxContainer />;
};

export default LetterBox;
